import axios from 'axios';
import { Notyf } from 'notyf';
import { API_BASE_URL } from '../../../config/config';
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

const notyf = new Notyf({
    dismissible: true, ripple: false,
    duration: 1000,
    position: { x: 'rigth', y: 'top' },
    types: [
      {
        type: 'warning',
        background: 'orange',
        icon: { className: 'material-icons', tagName: 'i', text: 'warning' }
      },
      {
        type: 'error',
        background: 'indianred',
        duration: 3000,
        dismissible: true
      }
    ]
  });
  

export default function SignUp() {

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);


    const [formData, setFormData] = useState({
        name: '',
        subname: '',
        surname: '',
        email: '',
        birthday: '',
        password: '',
        confirmPassword: '',
        phone: ''
    });

    const handleChange = (e) => {
        const { placeholder, value } = e.target;
        const key = {
            'name': 'name',
            'subname': 'subname',
            'surname': 'surname',
            'E-Mail': 'email',
            'numéro-whatsapp': 'phone',
            'Date de naissance': 'birthday',
            'Password': 'password',
            'Confirmer Password': 'confirmPassword'
        }[placeholder.trim()];
        setFormData({ ...formData, [key]: value });
    };

    const isFormValid = () => {
        for (let key in formData) {
            if (formData[key].trim() === '') {
                notyf.error(`Le champ "${key}" est obligatoire.`);
                return false;
            }
        }

        if (formData.password !== formData.confirmPassword) {
            notyf.error("Les mots de passe ne correspondent pas.");
            return false;
        }

        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!isFormValid()) return;

        try {
            await axios.post(`${API_BASE_URL}/auth/signup`, formData);
            notyf.success('Inscription réussie !');
            window.location.href="/mksp/login"
            // Réinitialiser le formulaire si besoin
            setFormData({
                name: '',
                subname: '',
                surname: '',
                email: '',
                birthday: '',
                password: '',
                confirmPassword: '',
                phone: ''
            });
        } catch (error) {
            console.error('Erreur lors de l’envoi :', error);
            notyf.error('Erreur lors de l’envoi');
        }
    };



    return (
        <>
             <div className="flex mt-10 mb-20 text-center content-center justify-center p-2 py-6  ">
                <div className="">
                    {/* ////////// */}

                    {/* /////// */}
                                 {/* <LogoMksp/>  */}
                            <div className="h-2 w-full rounded-b rounded-full bgC"></div>
                    <div className=" dark:bg-gray-900 bg-white justify-center py-6 rounded-lg content-center text-center  p-3 shadow-lg w-full max-w-md">
                        <div className="flex px-5  gap-4">
                            <div>

                                 <h1 className="">Creer Votre Compt MKSP Maintenant </h1>
                            </div>
                        </div>
                        <form onSubmit={handleSubmit} className="max-w-md mx-auto p-4 relative">
                            <input
                                type="text"
                                placeholder="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="w-full dark:border-gray-700 rounded border p-2 dark:bg-gray-800 mb-2"
                            />

                            <input
                                type="text"
                                placeholder="subname"
                                value={formData.subname}
                                onChange={handleChange}
                                className="w-full dark:border-gray-700 rounded border p-2 dark:bg-gray-800 mb-2"
                            />

                            <input
                                type="text"
                                placeholder="surname"
                                value={formData.surname}
                                onChange={handleChange}
                                className="w-full dark:border-gray-700 rounded border p-2 dark:bg-gray-800 mb-2"
                            />

                            <input
                                type="text"
                                placeholder="E-Mail"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full dark:border-gray-700 rounded border p-2 dark:bg-gray-800 mb-2"
                            />

                            <input
                                type="text"
                                placeholder="numéro-whatsapp"
                                value={formData.phone}
                                onChange={handleChange}
                                className="w-full dark:border-gray-700 rounded border p-2 dark:bg-gray-800 mb-2"
                            />

                            <label className="font-semibold dark:text-white text-black">
                                Date de naissance
                            </label>
                            <input
                                type="date"
                                placeholder="Date de naissance"
                                value={formData.birthday}
                                onChange={(e) =>
                                    setFormData({ ...formData, birthday: e.target.value })
                                }
                                className="w-full dark:border-gray-700 border rounded p-2 dark:bg-gray-800 mt-2 mb-2"
                            />

                            {/* Mot de passe */}
                            <div className="relative w-full mb-2">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    className="w-full dark:border-gray-600 rounded border p-2 dark:bg-gray-800"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-3 top-2 text-gray-500 hover:text-gray-800 dark:hover:text-gray-200"
                                >
                                    {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>

                            {/* Confirmation */}
                            <div className="relative w-full mb-2">
                                <input
                                    type={showConfirm ? "text" : "password"}
                                    placeholder="Confirmer Password"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                    className="w-full dark:border-gray-600 rounded border p-2 dark:bg-gray-800"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowConfirm(!showConfirm)}
                                    className="absolute right-3 top-2 text-gray-500 hover:text-gray-800 dark:hover:text-gray-200"
                                >
                                    {showConfirm ? <EyeOff size={18} /> : <Eye size={18} />}
                                </button>
                            </div>

                            <button
                                type="submit"
                                className="w-full rounded bg-blue-600 text-white py-2"
                            >
                                Créer votre compte
                            </button>
                        </form>


                        {/* <div className="flex items-center mb-4">
                            <input type="checkbox" className="mr-2" />
                            <span className="text-gray-400 text-sm">By signing up, you agree to our Terms of Use and Privacy Policy.</span>
                        </div> */}



                        <p className="text-gray-400  mt-4 text-center">Vous avez déjà un compte ? <a href="/mksp/login" className="text-blue-400"> Connectez-vous ici</a></p>
                    </div>
                </div>
            </div>
        </>
    )
}